 import { useMutation } from "@tanstack/react-query";
import { DashboardServiceImpl } from "features/dashboard/domain/services/dashboardService";
import { CampaignModelMapper } from "features/campaign/domain/models/campaignModel";

const DashboardService = new DashboardServiceImpl();


export const useCreateCustomCampaignLink = (
  onError?: (error: Error) => void,
  onSuccess?: (data: CampaignModelMapper) => void
) => {
  return useMutation({
    mutationFn: ({campaignId, url}: {campaignId: string, url: string}) =>
      DashboardService.createCustomCampaignLink(campaignId, url),
    onError,
    onSuccess,
  });
};

